import React from 'react'

export const VectorIcon = () => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
  <path d="M2.69796 18.8973H4.3152L15.4089 7.80365L13.7916 6.18642L2.69796 17.2801V18.8973ZM0.428162 21.1671V16.3438L15.4089 1.39146C15.6358 1.18339 15.8866 1.02262 16.1613 0.909127C16.4359 0.795637 16.7242 0.738892 17.0261 0.738892C17.328 0.738892 17.6212 0.795637 17.9056 0.909127C18.1901 1.02262 18.436 1.19285 18.6433 1.41983L20.2038 3.00869C20.4308 3.21676 20.5965 3.46265 20.7009 3.74638C20.8053 4.0301 20.8571 4.31383 20.8564 4.59755C20.8564 4.90019 20.8046 5.18884 20.7009 5.46348C20.5972 5.73813 20.4315 5.98856 20.2038 6.21479L5.25149 21.1671H0.428162ZM14.5861 7.00922L13.7916 6.18642L15.4089 7.80365L14.5861 7.00922Z" fill="#A8D727"/>
</svg>
  )
}
